import React from 'react';
import {
    ActiveDrafts,
    ImportHistory,
    PendingInvoices,
    PurchaseHeader,
    PurchaseSummary,
} from './components';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

/**
 * Layout for the Purchases page. Renders the page header (right-aligned
 * action buttons) above the headline `PurchaseSummary` widget. Sibling
 * widgets are stacked vertically with consistent `gap-8` rhythm to match
 * the Sales page. No padding is applied here — the layout's main content
 * area already provides it (see `AppShell`).
 */
export const PurchasesView: React.FC = () => {
    return (
        <div
            className="mx-auto flex w-full max-w-7xl flex-col gap-8"
            {...getNodeTestIdProp('purchases-page')}
            id="purchases-page"
        >
            <PurchaseHeader />
            <PurchaseSummary />
            <PendingInvoices />
            <ActiveDrafts />
            <ImportHistory />
        </div>
    );
};
